export default __webpack_public_path__ + "static/media/ApprovedRelocationIcon.39b53c03.svg";